import { render, staticRenderFns } from "./UpdateContent.vue?vue&type=template&id=ae07907a&scoped=true&"
import script from "./UpdateContent.vue?vue&type=script&lang=js&"
export * from "./UpdateContent.vue?vue&type=script&lang=js&"
import style0 from "./UpdateContent.vue?vue&type=style&index=0&id=ae07907a&lang=scss&scoped=true&"
import style1 from "./UpdateContent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae07907a",
  null
  
)

export default component.exports